import { GenericService } from 'services/genericService';
import { getSubscriberProducts } from 'utils/api/queries/omantelMicroApi';
import { Observable } from 'rxjs';
import { SubscriberProducts } from 'utils/api/models/subscriberProducts/subscriberProducts';

export class SubscriberProductsService extends GenericService {
	public static getSubscriberProducts(
		phoneNumber: string,
		billingType: string,
		accountType: string
	): Observable<SubscriberProducts> {
		return getSubscriberProducts(phoneNumber, billingType, accountType).call();
	}
}
